// ─────────────────────────────────────────────
// hooks/useToast.js
// Simple toast notification state hook
// License: MIT (your original IP)
// ─────────────────────────────────────────────

import { useState } from "react";

export function useToast(duration = 3000) {
  const [toast, setToast] = useState("");

  function showToast(msg) {
    setToast(msg);
    setTimeout(() => setToast(""), duration);
  }

  return { toast, showToast };
}
